<label
  class="app-checkbox"
  [ngClass]="[
    checked ? 'app-checkbox--checked' : '',
    indeterminate ? 'app-checkbox--indeterminate' : '',
    disabled ? 'app-checkbox--disabled' : '',
    customClass
  ]"
  (click)="toggle($event)"
>
  <div class="app-checkbox__box">
    <!-- Checkmark SVG (matching Expense exactly) -->
    <svg
      *ngIf="checked && !indeterminate"
      class="app-checkbox__icon"
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 4L3.75 6.5L8.75 1.5"
        stroke="white"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <!-- Indeterminate Dash SVG -->
    <svg
      *ngIf="indeterminate"
      class="app-checkbox__icon"
      width="10"
      height="2"
      viewBox="0 0 10 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 1H8.5"
        stroke="white"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>

  <span class="app-checkbox__label" *ngIf="labelText || label">
    {{ labelText || label }}
  </span>
  <span class="app-checkbox__content">
    <ng-content></ng-content>
  </span>
</label>
